import React from 'react';

export const ChasersContext = React.createContext();
ChasersContext.displayName = 'Chasers context provider';

export const ChasersProvider = ChasersContext.Provider;
